import React from 'react';
import type { ISnapIcon } from '../icons-mapper';

export const Exclamation = (props: ISnapIcon) => {
  const { size, title, color = 'currentColor' } = props;
  return (
    <svg
      height={size}
      width={size}
      viewBox='0 0 20 20'
      xmlns='http://www.w3.org/2000/svg'
    >
      <title>{title}</title>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.25697 3.0991C9.02197 1.7391 10.979 1.7391 11.743 3.0991L17.323 13.0191C18.073 14.3531 17.11 15.9991 15.581 15.9991H4.41997C2.88997 15.9991 1.92697 14.3531 2.67697 13.0191L8.25697 3.0991ZM11 13.0001C11 13.2653 10.8946 13.5197 10.7071 13.7072C10.5195 13.8947 10.2652 14.0001 9.99997 14.0001C9.73475 14.0001 9.4804 13.8947 9.29286 13.7072C9.10533 13.5197 8.99997 13.2653 8.99997 13.0001C8.99997 12.7349 9.10533 12.4805 9.29286 12.293C9.4804 12.1055 9.73475 12.0001 9.99997 12.0001C10.2652 12.0001 10.5195 12.1055 10.7071 12.293C10.8946 12.4805 11 12.7349 11 13.0001ZM9.99997 5.0001C9.73475 5.0001 9.4804 5.10546 9.29286 5.29299C9.10533 5.48053 8.99997 5.73488 8.99997 6.0001V9.0001C8.99997 9.26532 9.10533 9.51967 9.29286 9.70721C9.4804 9.89474 9.73475 10.0001 9.99997 10.0001C10.2652 10.0001 10.5195 9.89474 10.7071 9.70721C10.8946 9.51967 11 9.26532 11 9.0001V6.0001C11 5.73488 10.8946 5.48053 10.7071 5.29299C10.5195 5.10546 10.2652 5.0001 9.99997 5.0001Z'
        fill={color}
      />
    </svg>
  );
};
